module.exports = "/_next/static/images/9de9a0f9dd55364b3fb689394df91231-worldcup-lg-2x.jpg.webp";